module.exports = __webpack_public_path__ + "img/2021_10_dande_nishihonganji_1011_fin_web.e7cf4d6b.jpg";